import React, { Component } from "react";
import { getUsers, redirectTo , getAreas, getDepartments} from "./actions";
import { Typography, Grid } from "@material-ui/core";
import { connect } from "react-redux";
import { hot } from "react-hot-loader";

import { DisplayWidget } from "../UI/DisplayWidget";
import PersonIcon from "@material-ui/icons/Person";

class TotalClientInfoWidget extends Component {
    constructor(props) {
        super(props);
        props.getAreas();
        props.getDepartments();
        props.getUsers();
    }

    render() {
        const { details, lg, md, sm } = this.props;

        return (
            <Grid item sm={sm} md={md} lg={lg}>
                <DisplayWidget
                    color="white"
                    background="#0188CC"
                    Icon={PersonIcon}
                    click={() => {
                        this.props.redirectTo("/user-manager");
                    }}
                    primaryText={
                        <Typography
                            variant="subtitle2"
                            style={{ color: "inherit" }}
                        >
                            <b>Total Users </b>
                        </Typography>
                    }
                    secondaryText={
                        <Typography variant="h6" style={{ color: "inherit" }}>
                            {details ? details : 0}
                        </Typography>
                    }
                />
            </Grid>
        );
    }
}

export default hot(module)(
    connect(
        (store, props) => {
            const { selectors } = props;
            const { selectDashDetails, selectAllDepartments, selectAllAreas } = selectors;
            return {
                details: selectDashDetails(store),
                allDepartments: selectAllDepartments(store),
                allAreas: selectAllAreas(store)
            };
        },
        { getUsers, redirectTo ,  getAreas, getDepartments }
    )(TotalClientInfoWidget)
);
